// utils/pdfExportUtils.ts
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { toast } from "react-toastify";

interface ExportPDFOptions {
  fileName: string;
  columns: string[];
  data: any[];
  emptyDataMessage?: string;
  footerRow?: string[];
}

export const exportToPDF = ({
  fileName,
  columns,
  data,
  emptyDataMessage = "No data available for export.",
  footerRow,
}: ExportPDFOptions) => {
  if (!data.length) {
    toast.warn(emptyDataMessage, {
      position: "top-right",
      autoClose: 1000,
      hideProgressBar: false,
      closeOnClick: true,
    });
    return;
  }

  const doc = new jsPDF();

  if (footerRow) {
    data.push(footerRow);
  }

  autoTable(doc, {
    head: [columns],
    body: data,
    startY: 20,
  });

  doc.save(`${fileName}.pdf`);
};
